import React, { FC, useState, ChangeEvent } from 'react';
import {
  DialogTitle,
  DialogActions,
  DialogContent,
  TextField,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';
import { ArticleFromUrl } from '../types';
import { getArticleInfoFromUrl } from '../../../utils/getArticleInfoFromUrl';
import { injectFocuspoint } from '../../../../../../../utils/media';
import {
  assertCharacterNotPresent,
  isValidUrl,
} from 'validator/textFieldValidator';

interface ContentFromURLDialogProps {
  closeDialog: () => void;
  addBlockFromArticle: (article: ArticleFromUrl) => void;
}

export const ContentFromURLDialog: FC<ContentFromURLDialogProps> = ({
  closeDialog,
  addBlockFromArticle,
}) => {
  const [articleLink, setArticleLink] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isErrored, setIsErrored] = useState<boolean>(false);

  const setInfoFromArticleUrl = async () => {
    setIsLoading(true);
    setIsErrored(false);
    const urlValidation =
      isValidUrl(articleLink) && assertCharacterNotPresent(articleLink, '#');

    if (!urlValidation) {
      setIsErrored(true);
      setIsLoading(false);

      return;
    }
    try {
      const articleInfo = await getArticleInfoFromUrl(articleLink);
      const media =
        articleInfo.media && (await injectFocuspoint(articleInfo.media));
      closeDialog();
      addBlockFromArticle({ ...articleInfo, media });
    } catch (e) {
      setIsLoading(false);
      setIsErrored(true);
    }
  };

  return (
    <>
      <DialogTitle>Saisissez le lien vers l'article à récupérer</DialogTitle>
      <DialogContent>
        <TextField
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setArticleLink(e.target.value)
          }
          value={articleLink}
          fullWidth
          autoFocus
          variant="standard"
        />
        {isErrored && (
          <Typography color="error">
            Une erreur est survenue avec le lien que vous avez fourni.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={setInfoFromArticleUrl}
        >
          {isLoading ? (
            <CircularProgress thickness={5} color="secondary" size={25} />
          ) : (
            'OK'
          )}
        </Button>
      </DialogActions>
    </>
  );
};
